<header class="AMNavbar_header bg-am-premium-blue text-am-white d-flex flex-column">
  <nav>
    <div class="divs-am-row">
      <div class="border-am-right pe-4 position-relative" routerLink="/" [ngClass]="{'AMNavbar_icon--short': showShortIcon,'AMNavbar_icon--full': !showShortIcon}">
        <img [src]="logoURL" alt="aeromexico">
      </div>
      <div class="mx-2">
        <am-clock [isrb]="isrb"></am-clock>
      </div>
    </div>
    <div class="d-flex fw-medium-x align-items-center">
    <div *ngIf="showStepper" class="" [ngClass]="{'mx-10':idLang=='zh_CN'||idLang=='kr_KR','mx-5':idLang=='du_NL'||idLang=='pt_PT','mx-7':idLang=='en_US','mx-3':idLang == 'es_MX' || idLang == 'fr_FR'||idLang=='ja_JP' }">
        <app-stepper-bags
          [step]="step"
        ></app-stepper-bags>
      </div>
      <div *ngIf="showResumeFlight" class="mx-2">
        <button class="AMNavbar_button-resume d-flex flex-row fs-20px text-center align-items-center ml-3" (click)="onOpenResume()" *ngIf="showStartOver">
          {{ ('flightSummary.fightResume' | translate) |  uppercase}}
        </button>
      </div>

      <div class="divs-am-row mx-3" *ngIf="showLanguagesButton">

        <app-button-languages [showTextLenguages]="showTextLenguages"></app-button-languages>
      </div>
      <div *ngIf="showStartOver" class="mx-2">
        <button class="AMNavbar_button-startover d-flex flex-row fs-20px text-center fw-regular align-items-center ml-3 txt-garnett-Semibold-18" (click)="onStarOver()" *ngIf="showStartOver">
          <span class="mx-2"> <i class="fas fa-undo fa-rotate-90"></i></span><span class="txt-garnett-Semibold-18">{{ 'startOver' | translate}}</span>
        </button>
      </div>
      <div class="position-relative" *ngIf="showSkyPriority">
        <div class="header-sky-priority" >
         <img src="assets/images/skypriority.jpg" alt="" width="100px" height="36px">
        </div>
      </div>
    </div>
  </nav>
  <ngb-progressbar
    type="info"
    [value]="status"
    [max]="100"
    height="100px"
  ></ngb-progressbar>
</header>
<div class="AMNavbar_space"></div>

